import _ from "lodash";

import Box from "components/Box";
import ContentSeparator from "components/ContentSeparator";
import Image from "components/Image";
import SanitizeHtml from "components/SanitizeHtml";
import Stack from "components/Stack";
import Text from "components/Text";

import NoContent from "entities/Deal/components/OverviewSections/NoContent";
import UnitAmenitiesTable from "entities/Deal/components/OverviewUnitAmenities/UnitAmenitiesTable";
import { useDealUnitAmenitiesManager } from "entities/Memo/utils";

interface IPrintableOverviewUnitAmenities {
  dealId: number;
  externalToken?: string;
  displayImage?: boolean;
}

const PrintableOverviewUnitAmenities = ({
  dealId,
  externalToken,
  displayImage = true,
}: IPrintableOverviewUnitAmenities) => {
  const { data: dealUnitAmenities } = useDealUnitAmenitiesManager({
    dealId,
    token: externalToken,
  });

  if (!dealUnitAmenities) {
    return null;
  }

  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between">
        <Text variant="h2" data-testid="section-header-name">
          Unit Amenities
        </Text>
      </Stack>
      <ContentSeparator label="Unit Amenities" />
      <UnitAmenitiesTable
        unit_amenities_data={dealUnitAmenities}
        tableDataTestid="unit-amenities-categories-tables"
      />

      {displayImage && dealUnitAmenities.image && (
        <Stack spacing={2}>
          <Image
            src={dealUnitAmenities.image}
            imgix
            imgixHeight={920}
            sx={{ height: "460px", width: "100%", objectFit: "cover" }}
            imageDataTestid="uploaded-unit-amenities-image"
          />
        </Stack>
      )}
      <ContentSeparator label="Unit Amenities Description" />
      <Box
        sx={{
          paddingLeft: 1,
          "*": { lineHeight: "140% !important" },
          table: {
            width: "100%",
          },
          "table, th, td, tr": {
            borderCollapse: "collapse",
            border: "1px solid black !important",
          },
        }}
        data-testid="unit-amenities-description"
      >
        {_.isEmpty(dealUnitAmenities.description) ? (
          <NoContent />
        ) : (
          <SanitizeHtml
            html={dealUnitAmenities.description}
            dataTestid="unit-amenities-description-added"
          />
        )}
      </Box>
    </Stack>
  );
};

export default PrintableOverviewUnitAmenities;
